
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillInvoice } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        invoices: {
            type: [Array, null] as PropType<Array<WaybillInvoice>>,
            default: null
        },
    },
})
